<template lang="html">
  <div class="container" id="text-page">
    <h1 class="page-title txt-black">Política de envío, devolución y reembolso</h1>

    <div v-html="body"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      body:null,
    }
  },
  methods:{
      getHome(){
        axios.get(tools.url("/api/devoluciones")).then((response)=>{
            this.body=response.data.body;
          }).catch((error)=>{
        });
      },
  },
  mounted(){
    this.getHome();
  }
}
</script>